import React from "react";
import { Typography, Layout, Divider, Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Title, Paragraph } = Typography;
const { Content } = Layout;

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div>
            <Button
        type="link"
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate("/")}
        style={{
          top: "24px",
          fontSize: "16px",
          marginLeft:"180px",
          fontWeight: 500,
          fontFamily: "Inter, sans-serif",
        }}
      >
        Back
      </Button>
    <Content
      style={{
        margin: "0 auto",
        padding: "40px 24px",
        maxWidth: "900px",
        fontFamily: "Inter, sans-serif",
        borderRadius: "12px",
        overflowY:"auto"
      }}
    >


        <Typography>
          <Title level={1} style={{ fontSize: "42px", fontWeight: 700 }}>
            Terms of Service
          </Title>
          <Paragraph style={{ fontSize: "16px", color: "#555" }}>
            Welcome to <strong>themedianest.ai</strong>, a service provided by{" "}
            <strong>3G Technologies Ltd</strong>. By using our website and
            services, you agree to be bound by the following Terms of Service.
          </Paragraph>

          <Divider />

          <Title level={4}>Overview of Services</Title>
          <Paragraph>
            themedianest.ai enables users to select news from RSS feeds,
            convert them into readable articles and headlines, and further
            transform them into video and audio formats.
          </Paragraph>

          <Title level={4}>Account Registration</Title>
          <Paragraph>
            To use our services, users must create an account. You are
            responsible for maintaining the confidentiality of your account
            credentials.
          </Paragraph>

          <Title level={4}>Intellectual Property</Title>
          <Paragraph>
            All original content and software on the platform are the property
            of 3G Technologies Ltd. You may use AI-generated outputs for
            personal or commercial use, but the service infrastructure and tools
            remain proprietary.
          </Paragraph>

          <Title level={4}>Termination</Title>
          <Paragraph>
            We reserve the right to suspend or terminate your account for any
            violations of these terms or illegal use of the platform.
          </Paragraph>

          <Title level={4}>Disclaimer</Title>
          <Paragraph>
            The service is provided "as is" without warranties of any kind. We
            are not liable for any direct or indirect damages resulting from the
            use of the platform.
          </Paragraph>
        </Typography>
    </Content>
    </div>

  );
};

export default TermsOfService;
